import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PayPalButtons } from "@paypal/react-paypal-js";
import publicApi from "../api/axiosPublic";
import "../styles/checkout.css";

export default function Checkout() {
  const { cursoId } = useParams();
  const navigate = useNavigate();

  const [curso, setCurso] = useState(null);
  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    nombre: "",
    apellido: "",
    email: "",
    telefono: "",
    area_interes: "",
    acepta_marketing: false,
  });

  const [inscripcionId, setInscripcionId] = useState(null);
  const [mostrarResumen, setMostrarResumen] = useState(false);
  const [metodoPago, setMetodoPago] = useState("paypal");

  /* =============================
     CARGAR CURSO
  ============================== */
  useEffect(() => {
    publicApi.get(`/cursos/${cursoId}`)
      .then(res => setCurso(res.data))
      .catch(() => alert("No se pudo cargar el curso"))
      .finally(() => setLoading(false));
  }, [cursoId]);

  /* =============================
     FORM
  ============================== */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  /* =============================
     GUARDAR INSCRIPCIÓN
  ============================== */
  const handleGuardarDatos = async (e) => {
    e.preventDefault();

    try {
      const res = await publicApi.post("/checkout", {
        curso_id: Number(cursoId),
        ...form,
      });

      if (res.data.free) {
        navigate("/pago-exitoso");
        return;
      }

      setInscripcionId(res.data.inscripcionId);
      setMostrarResumen(true);
    } catch {
      alert("Error al guardar los datos");
    }
  };

  if (loading) return <p style={{ padding: 30 }}>Cargando...</p>;
  if (!curso) return <p style={{ padding: 30 }}>Curso no disponible</p>;

  return (
    <div className="checkout-container">
      <div className="checkout-card">
        <h1 className="checkout-title">Inscripción</h1>
        <p className="checkout-subtitle">
          Curso: <b>{curso.nombre}</b>
        </p>

        {/* FORM */}
        <form className="checkout-form" onSubmit={handleGuardarDatos}>

          <input
            name="nombre"
            placeholder="Nombre"
            value={form.nombre}
            onChange={handleChange}
            required
          />

          <input
            name="apellido"
            placeholder="Apellido"
            value={form.apellido}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Correo"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            name="telefono"
            placeholder="Teléfono"
            value={form.telefono}
            onChange={handleChange}
            required
          />

          <select
            name="area_interes"
            value={form.area_interes}
            onChange={handleChange}
            required
            className="checkout-select"
          >
            <option value="">Área de interés</option>
            <option value="Informática">Informática</option>
            <option value="Contabilidad">Contabilidad</option>
            <option value="Administración">Administración</option>
            <option value="Marketing">Marketing</option>
            <option value="Recursos Humanos">Recursos Humanos</option>
            <option value="Educación">Educación</option>
            <option value="Otro">Otro</option>
          </select>

          <label className="checkout-consent">
            <input
              type="checkbox"
              name="acepta_marketing"
              checked={form.acepta_marketing}
              onChange={handleChange}
            />
            <span>
              Acepto recibir información sobre nuevos cursos y contenidos relacionados a mis intereses.
            </span>
          </label>

          {!mostrarResumen && (
            <button className="checkout-btn" type="submit">
              Continuar
            </button>
          )}
        </form>

        {/* RESUMEN + PAGO */}
        {mostrarResumen && curso.precio > 0 && (
          <div className="checkout-grid">
            <div className="checkout-left">
              <h2>Resumen</h2>
              <p><b>Curso:</b> {curso.nombre}</p>
              <p><b>Total:</b> ${curso.precio}</p>
            </div>

            <div className="checkout-right">
              <h3>Método de pago</h3>

              <div className="metodos-pago">
                <label className={`metodo ${metodoPago === "paypal" ? "activo" : ""}`}>
                  <input
                    type="radio"
                    checked={metodoPago === "paypal"}
                    onChange={() => setMetodoPago("paypal")}
                  />
                  <img src="/img/paypal.png" alt="PayPal" />
                </label>

                <label className={`metodo ${metodoPago === "webpay" ? "activo" : ""}`}>
                  <input
                    type="radio"
                    checked={metodoPago === "webpay"}
                    onChange={() => setMetodoPago("webpay")}
                  />
                  <img src="/img/webpay.png" alt="Webpay" />
                </label>
              </div>

              {metodoPago === "paypal" && (
                <PayPalButtons
                  style={{ layout: "vertical" }}
                  createOrder={async () => {
                    const res = await publicApi.post("/paypal/create-order", { inscripcionId });
                    return res.data.orderId;
                  }}
                  onApprove={async (data) => {
                    await publicApi.post("/paypal/capture-order", {
                      orderId: data.orderID,
                      inscripcionId,
                    });
                    navigate("/pago-exitoso");
                  }}
                  onCancel={() => navigate("/pago-fallido")}
                  onError={() => navigate("/pago-fallido")}
                />
              )}

              {metodoPago === "webpay" && (
                <button
                  className="checkout-btn webpay"
                  type="button"
                  onClick={async () => {
                    const res = await publicApi.post("/webpay/create", { inscripcionId });

                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = res.data.url;

                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = "token_ws";
                    input.value = res.data.token;

                    form.appendChild(input);
                    document.body.appendChild(form);
                    form.submit();
                  }}
                >
                  Pagar con Webpay
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
